import * as React from 'react'

import { cn } from '@/lib/utils'
import { Heading } from '@/components/ui/Heading'
import { Text } from '@/components/ui/Text'

interface LobbyEmptyStateProps {
  title: string
  description: string | React.ReactNode
  className?: string
  children?: React.ReactNode
}

export function LobbyEmptyState(props: LobbyEmptyStateProps) {
  const { title, description, className, children } = props

  return (
    <div
      className={cn(
        'col-span-full rounded-lg border-dashed-6 flex flex-col items-center justify-center text-center px-5 py-7 md:p-10 gap-5',
        className,
      )}
    >
      <div className="flex flex-col items-center gap-2 w-full">
        <Heading level={3} className="text-lg font-medium font-sans text-foreground text-center w-full">
          {title}
        </Heading>
        <Text size="base" color="muted" className="text-center max-w-[823px]">
          {description}
        </Text>
      </div>
      {children}
    </div>
  )
}
